import { SubjectData } from 'shell/models/person';
import { ParentVM } from 'civil-status/view-models/step-form';
import { initialValuesParent } from 'civil-status/constants/initial-values-step';

export const transformerSpouse = (person: SubjectData): ParentVM | undefined => {
  if (!Boolean(person.matrimonio?.coniuge)) {
    return;
  }

  const coniuge = person.matrimonio?.coniuge || {};
  const isConiugeWithFiscalCode = Boolean(coniuge.codiceFiscale?.codFiscale);

  // if (
  //   person.statoCivile?.statoCivile === CivilStatusID.vedovo ||
  //   person.statoCivile?.statoCivile === CivilStatusID.scioglimentoUnitoCivilmenteASeguitoDelDecesso
  // ) {
  //   return {
  //     generality: {
  //       ...initialValuesParent.generality,
  //       idAnpr: coniuge?.idSchedaSoggettoANPR || '',
  //       fiscalCode: coniuge?.codiceFiscale?.codFiscale || '',
  //       surname: coniuge?.cognome || '',
  //       name: coniuge?.nome || '',
  //       gender: coniuge?.sesso || '',
  //       birthDate: coniuge?.dataNascita ? DateTime.fromISO(coniuge?.dataNascita) : null,
  //       isForeignBorn: Boolean(coniuge?.luogoNascita?.localita),
  //       // generality italian form
  //       italian: coniuge?.luogoNascita?.comune
  //         ? {
  //             location: coniuge?.luogoNascita?.comune?.descrizioneLocalita || '',
  //             province: coniuge?.luogoNascita?.comune?.siglaProvinciaIstat || '',
  //             municipality: coniuge?.luogoNascita?.comune?.codiceIstat
  //               ? {
  //                   id: coniuge?.luogoNascita?.comune?.codiceIstat || '',
  //                   description: coniuge?.luogoNascita?.comune?.nomeComune || '',
  //                   province: coniuge?.luogoNascita?.comune?.siglaProvinciaIstat || '',
  //                   code: person.idComuneNascita || '',
  //                   idProvince: person.idProvNascita || '',
  //                 }
  //               : null,
  //           }
  //         : undefined,
  //       // generality foreign form
  //       foreign: coniuge?.luogoNascita?.localita
  //         ? {
  //             state: coniuge?.luogoNascita?.localita?.codiceStato
  //               ? {
  //                   id: coniuge?.luogoNascita?.localita?.codiceStato || '',
  //                   code: person.idStatoNascita || '',
  //                   value: coniuge?.luogoNascita?.localita?.descrizioneStato || '',
  //                   province: coniuge?.luogoNascita?.localita?.provinciaContea || '',
  //                 }
  //               : null,
  //             locationForeignBirth: coniuge?.luogoNascita?.localita?.descrizioneLocalita || '',
  //           }
  //         : undefined,
  //     } as AccordionGeneralityForm,
  //   };
  // }

  return {
    searchPerson: isConiugeWithFiscalCode
      ? { fiscalCode: coniuge.codiceFiscale?.codFiscale }
      : undefined,
    generality: {
      ...initialValuesParent.generality,
      name: coniuge.nome || '',
      surname: coniuge.cognome || '',
      gender: coniuge.sesso || '',
    },
  };
};
